// extracted by mini-css-extract-plugin
module.exports = {"uploadBtn":"styles_uploadBtn__3SPds","fileInput":"styles_fileInput__21_kX","eventBanner":"styles_eventBanner__3qJMi","eventDescription":"styles_eventDescription__3DIPp"};